import Grid from "@Components/Grid";
import Paper from "@Components/Paper";
import { TradeIn as TradeInType } from "@Types/deal";
import { renderFieldData } from "@Components/FieldData/RenderFieldData";

type TradeInProps = {
  tradeIn: TradeInType | undefined;
};

const TradeIn = ({ tradeIn }: TradeInProps) => {
  return tradeIn ? (
    <Paper
      title={"Trade In"}
      style={{ height: "100%", boxSizing: "border-box" }}
    >
      <Grid container xs={12}>
        <Grid xs={12}>{renderFieldData("VIN", tradeIn.VIN ?? "N/A")}</Grid>
        <Grid xs={12}>
          {renderFieldData("Year", tradeIn?.year?.toString() ?? "N/A")}
        </Grid>
        <Grid xs={12}>{renderFieldData("Make", tradeIn.make ?? "N/A")}</Grid>
        <Grid xs={12}>{renderFieldData("Model", tradeIn.model ?? "N/A")}</Grid>
      </Grid>
    </Paper>
  ) : null;
};
export default TradeIn;
